import React, { Suspense } from 'react';
import { createBrowserRouter, Navigate, type RouteObject } from 'react-router-dom';
import { Spin } from 'antd';
import AuthLayout from '@/layouts/AuthLayout';
import MainLayout from '@/layouts/MainLayout';
import ProtectedRoute from '@/router/ProtectedRoute';
import RoleGuard from '@/router/RoleGuard';
import {
  LoginPage,
  DashboardPage,
  AlertsPage,
  PromptsListPage,
  PromptDetailPage,
  InboxPage,
  ArticleDetailPage,
  CalendarPage,
  TaxonomyPage,
  SettingsPage,
  SubscribersPage,
  ProfilePage,
  SupportPage,
  NotFoundPage,
  PrivacyPage,
} from '@/router/LazyPages';

const suspense = (Component: React.LazyExoticComponent<React.ComponentType>) => (
  <Suspense fallback={<Spin size="large" style={{ display: 'block', margin: '20% auto' }} />}>
    <Component />
  </Suspense>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to="/dashboard" replace />,
  },
  {
    path: '/privacy',
    element: suspense(PrivacyPage),
  },
  {
    path: '/login',
    element: <AuthLayout />,
    children: [
      {
        index: true,
        element: suspense(LoginPage),
      },
    ],
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <MainLayout />,
        children: [
          {
            path: '/dashboard',
            element: suspense(DashboardPage),
          },
          {
            path: '/dashboard/alerts',
            element: suspense(AlertsPage),
          },
          {
            path: '/prompts',
            element: suspense(PromptsListPage),
          },
          {
            path: '/prompts/:id',
            element: suspense(PromptDetailPage),
          },
          {
            path: '/inbox',
            element: suspense(InboxPage),
          },
          {
            path: '/articles/:id',
            element: suspense(ArticleDetailPage),
          },
          {
            path: '/calendar',
            element: suspense(CalendarPage),
          },
          {
            path: '/taxonomy',
            element: suspense(TaxonomyPage),
          },
          {
            path: '/settings',
            element: suspense(SettingsPage),
          },
          {
            path: '/subscribers',
            element: <RoleGuard allowedRoles={['admin']}>{suspense(SubscribersPage)}</RoleGuard>,
          },
          {
            path: '/profile',
            element: suspense(ProfilePage),
          },
          {
            // /support e sub-path (/support/inbox, /support/prompts, ecc)
            path: '/support/*',
            element: suspense(SupportPage),
          },
          {
            path: '*',
            element: suspense(NotFoundPage),
          },
        ],
      },
    ],
  },
];

export const router = createBrowserRouter(routes);
